import * as THREE from 'three';
import RotationControl from "./RotationControl";
import PolycubeMesh from "./PolycubeMesh";
import GeometryManager from "./GeometryManager";
const DEFAULT_WIDTH = 640;
const DEFAULT_HEIGHT = 480;
export default class PolycubeScene {
    renderer;
    camera;
    mainScene;
    polycubeMeshes = [];
    controls;
    light;
    cubeScene;
    geomManager;
    canvas;
    loadedCb = () => { };
    loaded = false;
    windowDims;
    constructor(windowDims) {
        this.windowDims = windowDims ?? { width: DEFAULT_WIDTH, height: DEFAULT_HEIGHT };
        this.init().then(() => this.loadedCb()).catch(e => console.log(e));
    }
    async init() {
        this.canvas = document.createElement("canvas");
        this.canvas.width = 0;
        this.canvas.height = 0;
        this.renderer = new THREE.WebGLRenderer({ canvas: this.canvas, antialias: true });
        this.setupCamera(this.canvas.clientWidth / this.canvas.clientHeight);
        this.setupLight();
        this.mainScene = new THREE.Scene();
        this.cubeScene = new THREE.Scene();
        this.mainScene.add(this.cubeScene, this.camera, this.light);
        this.cubeScene.rotateX(Math.PI / 4);
        this.cubeScene.rotateY(Math.PI / 4);
        this.controls = new RotationControl(this.cubeScene, this.polycubeMeshes, this.camera, this.canvas);
        this.geomManager = await new GeometryManager('./', () => {
            requestAnimationFrame((timestamp) => this.render(timestamp));
        });
        PolycubeMesh.setManager(this.geomManager);
        this.loaded = true;
    }
    setupCamera(aspect) {
        const fov = 60;
        const near = 0.1;
        const far = 15;
        this.camera = new THREE.PerspectiveCamera(fov, aspect, near, far);
        this.camera.position.z = 6;
        this.camera.lookAt(0, 0, 0);
    }
    mount(el) {
        this.updateDims(this.windowDims);
        el.append(this.canvas);
    }
    updateDims(windowDims) {
        this.windowDims.width = windowDims.width;
        this.windowDims.height = windowDims.height;
        this.canvas.width = this.windowDims.width;
        this.canvas.height = this.windowDims.height;
        this.camera.aspect = this.canvas.width / this.canvas.height;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(this.canvas.width, this.canvas.height);
    }
    resetDims() {
        this.windowDims.width = DEFAULT_WIDTH;
        this.windowDims.height = DEFAULT_HEIGHT;
        this.updateDims(this.windowDims);
    }
    onLoaded(cb) {
        if (this.loaded) {
            cb();
        }
        this.loadedCb = cb;
    }
    isLoaded() {
        return this.loaded;
    }
    showPolycube(voxelSpace) {
        this.controls.disableFly();
        this.clearScene();
        this.addPolycube(voxelSpace);
        this.polycubeMeshes[0].center();
    }
    showSolution(solution) {
        this.controls.enableFly();
        this.clearScene();
        const pieces = solution.getPieces();
        for (let i = 0; i < pieces.length; i++) {
            this.addPolycube(pieces[i]);
        }
    }
    clearScene() {
        this.polycubeMeshes.splice(0, this.polycubeMeshes.length);
        this.cubeScene.clear();
    }
    addPolycube(voxelSpace) {
        const newMesh = new PolycubeMesh(voxelSpace);
        this.polycubeMeshes.push(newMesh);
        this.cubeScene.add(newMesh.asObj3D());
    }
    setupLight() {
        const color = 0xFFFFFF;
        const intensity = 1;
        this.light = new THREE.DirectionalLight(color, intensity);
        this.light.position.set(4, 6, 24);
        this.light.lookAt(0, 0, 0);
    }
    render(time) {
        this.renderer.render(this.mainScene, this.camera);
        requestAnimationFrame((time) => this.render(time));
    }
}
